import { twMerge } from "tailwind-merge";

import { ClassName } from "shared/types";

import { default as LogoSvg } from "./logo.svg?react";

export const Logo = ({ className }: ClassName) => {
  return (
    <div className={twMerge("flex items-center gap-x-4", className)}>
      <LogoSvg />

      <span className="text-fiord text-sm leading-4 font-medium">
        Data Provider <br /> Occam.fi
      </span>
    </div>
  );
};
